module.exports = __webpack_public_path__ + "static/media/pdf.0c77f5c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/pdf.svg
// module id = 129
// module chunks = 0